export type MpfVariants = 'success' | 'error';

export interface MpfNotificationBannerProps {
  heading?: string;
  additionalText?: string;
  marginClass?: string;
  isNhsJurisdiction?: boolean;
  organisationPhoneNumber?: string;
  variants?: MpfVariants;
}

export const mpfNotificationBannerDefaults = {
  heading: 'Temporarily Paused',
  isNhsJurisdiction: true,
} satisfies Partial<MpfNotificationBannerProps>;
